import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type Props = {
  error?: string;
  onClose: () => void;
};

export const ErrorDialog: React.FC<Props> = (props) => {
  return (
    <Dialog open={!!props.error} onClose={props.onClose}>
      <DialogTitle>Whoops...</DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{whiteSpace: 'pre-line', lineHeight: 1.7}}
        >
          {props.error}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Close</Button>
        <Button
          onClick={() => {
            const blob = new Blob([props.error!], {
              type: 'text/plain;charset=utf-8',
            });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'i18n_error.txt';
            a.click();
            URL.revokeObjectURL(url);
            props.onClose();
          }}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};
